//This file is generated from c# do not modify, any changes will be overridden when re-generated.
  import { ModelBase } from "../../pillar/common/models/ModelBase";
  
  import { LookupModel } from './../../common/models/LookupModel';
  
  export class AddUserModel extends ModelBase {
      static readonly $typeName = 'AddUserModel';
      public emailAddress: string;
      public firstName: string;
      public identifier: string;
      public lastName: string;
      public systemAccountKey: string;
      public group: LookupModel;
      
  }



// WEBPACK FOOTER //
// ./src/app/customer/models/AddUserModel.ts